// src/store/useLang.js
import { create } from 'zustand';
import i18n from '../i18n'; // ВАЖНО: именно ../i18n, а не ../i18n/i18n

export const useLang = create((set) => ({
  lang: i18n.language || 'ru',
  setLang: (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('lang', lng);
    set({ lang: lng });
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lng;
    }
  }
}));
